import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';

interface CopyButtonProps {
  text: string;
  size?: 'small' | 'middle';
  className?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({ text, size = 'small', className }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable (e.g. insecure context) — silently ignore */
    }
  };

  return (
    <Tooltip title={copied ? 'Скопійовано' : 'Копіювати'}>
      <Button
        type="text"
        size={size}
        className={className}
        icon={copied ? <CheckOutlined /> : <CopyOutlined />}
        onClick={handleCopy}
        aria-label="Копіювати"
      />
    </Tooltip>
  );
};

export default CopyButton;
